module.exports = __webpack_public_path__ + "media/nudge.6457e314.mp3";